import { InputSchema, groupInput, input } from "@redotech/ui/form";
import { nonEmptyValidator } from "@redotech/ui/validators";
import { memo } from "react";
import { RedoTextInput } from "../../../../arbiter-components/input/redo-text-input";
import { Flex } from "../../../../flex";
import { canadaPostApiKeyValidator } from "./canada-post-api-key-validator";

export const CanadaPostCarrierInput = groupInput({
  apiKey: input<string>({ validator: canadaPostApiKeyValidator }),
  contractId: input<string>({ validator: nonEmptyValidator }),
  customerNumber: input<string>({ validator: nonEmptyValidator }),
  hasCreditCard: input<string>({ validator: nonEmptyValidator }),
});

export type CanadaPostCarrierValue = InputSchema.Value<
  typeof CanadaPostCarrierInput
>;

export type CanadaPostCarrierForm = InputSchema.Input<
  typeof CanadaPostCarrierInput
>;

export const canadaPostCarrierDefault = (): CanadaPostCarrierValue => ({
  apiKey: "",
  contractId: "",
  customerNumber: "",
  hasCreditCard: "",
});

export const CreateCanadaPostCarrierForm = memo(
  function CreateCanadaPostCarrierForm({
    carrierInput,
  }: {
    carrierInput: CanadaPostCarrierForm;
  }) {
    return (
      <Flex dir="column">
        <RedoTextInput
          label="API Key"
          placeholder="username:password"
          setValue={carrierInput.inputs.apiKey.setValue}
          value={carrierInput.inputs.apiKey.value}
        />
        <RedoTextInput
          label="Contract ID"
          placeholder=""
          setValue={carrierInput.inputs.contractId.setValue}
          value={carrierInput.inputs.contractId.value}
        />
        <RedoTextInput
          label="Customer Number"
          placeholder=""
          setValue={carrierInput.inputs.customerNumber.setValue}
          value={carrierInput.inputs.customerNumber.value}
        />
        <RedoTextInput
          label="Has Credit Card"
          placeholder=""
          setValue={carrierInput.inputs.hasCreditCard.setValue}
          value={carrierInput.inputs.hasCreditCard.value}
        />
      </Flex>
    );
  },
);
